import { Modal } from "react-bootstrap";
import ReactTooltip from "react-tooltip";

const ExpandedViewModal = ({ show, onHide, modalData }) => {
  if (!modalData) return null;

  const { heading, table_data, column_config, modalType } = modalData;

  const getTitle = () => {
    switch (modalType) {
      case "conditions":
        return "Conditions";
      case "footnotes":
        return "Footnotes";
      case "additional_codes":
        return "Additional Codes";
      default:
        return "";
    }
  };

  const formatCellData = (value, key, rowIndex) => {
    if (Array.isArray(value)) {
      if (value.length === 0) return "-";

      if (value.length <= 3) {
        return value.join(", ");
      } else {
        const displayText = value.slice(0, 3).join(", ") + "...";
        const tooltipId = `tooltip-${key}-${rowIndex}`;

        return (
          <div>
            <span data-tip data-for={tooltipId}>
              {displayText}
            </span>
            <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id={tooltipId}>
              {value.join(", ")}
            </ReactTooltip>
          </div>
        );
      }
    }
    return value || "-";
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header className="tw-flex tw-justify-between tw-items-center tw-w-full tw-border-b tw-border-gray-300 tw-py-2 tw-px-4">
        <Modal.Title className="tw-flex tw-gap-3">
          <span className="tw-text-label-md tw-font-semibold">{getTitle()}</span>
        </Modal.Title>
        <button onClick={onHide} className="tw-bg-transparent tw-border-none tw-outline-none tw-cursor-pointer">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1c1b1f">
            <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
          </svg>
        </button>
      </Modal.Header>
      <Modal.Body className="tw-overflow-y-auto tw-p-6">
        <div className="tw-space-y-8">
          {heading && <div className="tw-text-gray-600 tw-text-label-md tw-font-medium">{heading}</div>}

          <div className="tw-mt-8">
            <div className="tw-overflow-y-auto tw-max-h-[calc(70vh-80px)] tw-p-1">
              <table className="tw-w-full">
                <thead className="tw-bg-gray-50">
                  <tr>
                    {column_config &&
                      Object.keys(column_config).map((key) => (
                        <th
                          key={key}
                          className="
                            tw-px-4 tw-py-3 
                            tw-text-left 
                            tw-text-gray-900 tw-text-label-md tw-font-semibold
                            tw-border-b tw-border-t tw-border-l tw-border-r tw-border-gray-300
                            tw-bg-gray-100
                            tw-sticky -tw-top-2 tw-z-10
                          ">
                          {column_config[key]}
                        </th>
                      ))}
                  </tr>
                </thead>
                <tbody className="tw-bg-white">
                  {table_data &&
                    table_data.map((row, index) => (
                      <tr key={index} className={index % 2 === 0 ? "tw-bg-white" : "tw-bg-gray-50"}>
                        {column_config &&
                          Object.keys(column_config).map((key) => (
                            <td
                              key={key}
                              className="
                                tw-px-4 tw-py-3
                                tw-text-gray-700
                                tw-border tw-border-gray-300
                                tw-text-label-sm
                              ">
                              {formatCellData(row[key], key, index)}
                            </td>
                          ))}
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ExpandedViewModal;
